import { useKeycloak } from '@react-keycloak/web'
import { useContext } from 'react'
import { KeycloakActionType, MenuLinks } from '../../constants'
import { clearFakeAuthToken, UNKNOWN_TOKEN } from '../services/auth-utils'
import keycloakActions from '../services/keycloak-actions'
import { UserActionType, UserContext } from '../state/user-state'
import { useNavigate } from 'react-router-dom'

export default function useLogout() {
  const navigate = useNavigate()
  const { dispatch } = useContext(UserContext)
  const { keycloak } = useKeycloak()

  const logout = () => {
    clearFakeAuthToken()
    if (keycloak.authenticated) {
      keycloakActions({
        action: KeycloakActionType.LOGOUT,
        keycloak,
        redirectPath: MenuLinks.LANDING,
      })
    } else {
      dispatch({ type: UserActionType.SET_TOKEN, payload: { token: UNKNOWN_TOKEN } })
      navigate(MenuLinks.LANDING)
    }
  }

  return {
    logout,
  }
}
